import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
  Badge
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import ModalManager from '../../../../components/modal/ModalManager';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import {phoneNumberFormat, required} from '../../../../helpers/Validators';
import LoaderButton from '../../../../components/LoaderButton';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import FieldError from '../../../../components/FieldError';
import {numberWithCommas} from '../../../../helpers/Utils';
import CreatableSelect from 'react-select/creatable';
import {forEach, indexOf, find, map} from 'lodash';
import {store} from '../../../../AppRenderer';
import Api from '../../../../services/Api';
import Select from 'react-select';

const components = {
  DropdownIndicator: null,
};

const createOption = label => ({
  label,
  value: label,
});

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destInputValue: '',
    };
    const {groupMessageSettings} = store.getState().app;
    this.categoryOptions = map(groupMessageSettings['SMS'].destinationCategories, ({type, localeName}) => ({
      label: localeName,
      value: type,
    }));
    this.serviceOptions = map(groupMessageSettings['SMS'].services, item => ({
      label: item,
      value: item,
    }));
  }

  handleInputChange = destInputValue => {
    this.setState({ destInputValue });
  };

  handleKeyDown = (event, input) => {
    const { destInputValue } = this.state;
    if (!destInputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        this.setState({
          destInputValue: '',
        });
        input.onChange([...input.value, createOption(destInputValue)]);
        event.preventDefault();
    }
  };

  sendSMS = async values => {
    const {t} = this.props;
    const {service, message, destinations, destinationCategories} = values;
    const categories = destinationCategories.map(obj => obj.value);
    try {
      await Api.invoke('POST', '/admin-ui/group-message', {
        type: 'SMS',
        message,
        service: service.value,
        destinationCategories: categories,
        ...(indexOf(categories, 'SELECTED_USERS') >= 0 ?
          {destinations: destinations.map(obj => obj.value)} : null
        ),
      });
      NotificationManager.success(t('Group sms sent successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  ServiceSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );

  CategoriesSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
    />
  );

  DestinationsSelectAdapter = ({input, ...rest}) => (
    <CreatableSelect
      {...input}
      {...rest}
      isClearable
      isMulti
      menuIsOpen={false}
      components={components}
      inputValue={this.state.destInputValue}
      onInputChange={this.handleInputChange}
      onChange={value => {input.onChange(value);}}
      onKeyDown={e => {this.handleKeyDown(e, input);}}
      placeholder={this.props.t('Type destination mobile number and press enter...')}
    />
  );

  validate = values => {
    const error = {};
    const {destinations, destinationCategories} = values;
    if (!!find(destinationCategories, ['value', 'SELECTED_USERS']) && destinations) {
      if (destinations.length) {
        forEach(destinations, obj => {
          const err = phoneNumberFormat(obj.value);
          if (err) {
            error.destinations = err;
            return false;
          }
        });
      } else {
        error.destinations = this.props.t('Required');
      }
    }
    return error;
  };

  computeCharsCount = message => {
    let count = 0;
    if (message) {
      count = message.length;
    }
    return count;
  };

  computeSmsCounts = charsCount => {
    let count = 1;
    let firstPageLimit = 70;
    if (charsCount && charsCount > firstPageLimit) {
      firstPageLimit = 64;
      let remainedCharCount = charsCount - firstPageLimit;
      count += Math.ceil(remainedCharCount / 67);
    }
    return count;
  };

  openConfirmDialog = onConfirm => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('SMS Confirm'),
      body: t('Are you sure you want to send this group sms message?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            onConfirm();
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'light',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Send Group SMS')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.sendSMS}
                  validate={this.validate}
                  initialValues={{
                    service: this.serviceOptions[0],
                  }}
                  render={({values, handleSubmit, submitting, pristine, hasValidationErrors}) => {
                    const {destinationCategories, message} = values;
                    const messageCharsCount = this.computeCharsCount(message);
                    return (
                      <Form>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                           <span>
                             {t('Service')}
                             <span className="required">*</span>
                           </span>
                            <Field
                              name="service"
                              component={this.ServiceSelectAdapter}
                              options={this.serviceOptions}
                              validate={required}
                            />
                            <FieldError name='service' />
                          </Col>
                        </Row>
                        <Row className='mt-2'>
                          <Col className='col-lg-6 col-md-12'>
                           <span>
                             {t('Send to')}
                             <span className="required">*</span>
                           </span>
                            <Field
                              name="destinationCategories"
                              component={this.CategoriesSelectAdapter}
                              options={this.categoryOptions}
                              validate={required}
                              closeMenuOnSelect={false}
                            />
                            <FieldError name='destinationCategories' />
                          </Col>
                        </Row>
                        {!!destinationCategories && !!find(destinationCategories, ['value', 'SELECTED_USERS']) &&
                        <Row className='mt-2'>
                          <Col className='col-lg-6 col-md-12'>
                              <span>
                                {t('Destination Mobile Numbers')}
                                <span className="required">*</span>
                              </span>
                            <Field
                              name="destinations"
                              component={this.DestinationsSelectAdapter}
                            />
                            <FieldError name='destinations' />
                          </Col>
                        </Row>
                        }
                        <Row className='mt-2'>
                          <Col className='col-lg-6 col-md-12 pb-2'>
                            <TextField
                              item={{
                                required: true,
                                name: 'message',
                                i18n: t('Message'),
                                type: 'textarea',
                                rows: 3,
                              }}
                            />
                            <span>
                              <Badge color="light" pill>
                                {t('{{count}} sms', {
                                  count: numberWithCommas(this.computeSmsCounts(messageCharsCount)),
                                })}
                              </Badge>
                              <Badge color="light" className='mx-1' pill>
                                {t('{{count}} char(s)', {
                                  count: numberWithCommas(messageCharsCount),
                                })}
                              </Badge>
                            </span>
                          </Col>
                        </Row>
                        <LoaderButton
                          loading={submitting}
                          onClick={() => {
                            this.openConfirmDialog(
                              handleSubmit,
                            );
                          }}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-2 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Submit')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Create);
